import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[660px] flex items-center overflow-hidden" aria-label="网站主横幅">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautiful%20abstract%20artistic%20composition%20with%20flowing%20water%20droplets%20and%20gentle%20waves%20in%20soft%20warm%20emerald%20green%20and%20golden%20amber%20tones%2C%20dreamy%20ethereal%20atmosphere%2C%20smooth%20gradients%2C%20minimal%20clean%20design%2C%20professional%20corporate%20feel%2C%20no%20text%2C%20no%20people&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
          alt="喷水系统专业解决方案"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
            喷水系统专业解决方案
          </h1>
          <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 leading-relaxed">
            专业喷水系统全面指南，涵盖喷水设备类型、喷水技术原理、安装维护要点及选购建议。
            无论农业灌溉、景观喷水还是工业冷却，我们提供最权威的喷水方案。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category"
              className="whitespace-nowrap cursor-pointer px-8 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200"
            >
              查看设备分类
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap cursor-pointer px-8 py-3 rounded-md border border-white/40 text-white font-medium text-sm hover:bg-white/10 transition-colors duration-200"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}